import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '../Directives/Directives.module';
import { ValueMetricsModalComponent } from './value-metrics-modal.component';
import { ValueMetricsPaywallModalComponent } from './value-metrics-paywall-modal.component';

export const ValueMetricsModuleExports = [
    ValueMetricsModalComponent,
    ValueMetricsPaywallModalComponent
];

@NgModule({
    imports: [CommonModule, DirectivesModule],
    declarations: [...ValueMetricsModuleExports],
    exports: [...ValueMetricsModuleExports]
})
export class ValueMetricsModule {}
